import { Button, HorizontalDivider, Typography } from '@smartgift/frontend-toolkit';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { Advantages } from '@hero/components/organisms';
import { configs } from '@hero/configs';
import { usePurifyTranslation } from '@hero/hooks';
import { ROUTE_PATHS } from '@hero/routes';
import { handleRedirectSignIn } from '@hero/utils';

import * as S from './style';

export const SignInRedirectForm = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { purifyT } = usePurifyTranslation();

  const handleRedirectSignUp = () => {
    navigate(ROUTE_PATHS.SIGN_UP);
  };

  return (
    <>
      <S.SignInContent>
        <Typography variant="subtitle3Bold">{t('welcomeToMerchant')}</Typography>

        <S.SignInContentBody>
          <Typography variant="body1">{t('yourGiftingJourneyBeginsHere')}</Typography>
          <S.SignInCard>
            <Typography variant="body2" color="fg" emphasis="weak">
              {t('alreadyHaveAccountMessage')}
            </Typography>
            <Button onClick={handleRedirectSignIn} color="primary" block>
              {t('signIn')}
            </Button>
            <HorizontalDivider $margin="0 0 24px 0" />
          </S.SignInCard>
        </S.SignInContentBody>
        <S.SignInContentFooter>
          <S.SignUpWrapper>
            {configs.publicLogin.register && (
              <>
                <Typography variant="body2" color="fg" emphasis="weaker">
                  {t('newHere')}
                </Typography>
                <Button color="primary" onClick={handleRedirectSignUp} block variant="outlined">
                  {t('createAccount')}
                </Button>
              </>
            )}
          </S.SignUpWrapper>
        </S.SignInContentFooter>
        <S.SignInContentNote>
          <Typography
            variant="caption1"
            dangerouslySetInnerHTML={{ __html: purifyT('getStartedNote') }}
          />
        </S.SignInContentNote>
      </S.SignInContent>

      <Advantages />
    </>
  );
};
